"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchesPermissionResourceRequest = exports.MatchesPermissionResource = exports.EncodePermission = exports.EncodePermissionResource = exports.ParsePermission = exports.ParsePermissionResource = void 0;
const types_1 = require("./types");
__exportStar(require("./types"), exports);
function ParsePermissionResource(resource) {
    resource = resource || '*';
    const resourceUnions = resource.split('&');
    if (resourceUnions.length > 1) {
        throw new Error('Union Permissions are unsupported');
    }
    let resultResource;
    if (Object.values(types_1.PermissionResourceAlias).includes(resource)) {
        resultResource = resource;
    }
    const resourceParts = resource.split(':', 2);
    if (resourceParts.length > 1) {
        const qualifier = resourceParts[0];
        if (!Object.values(types_1.PermissionResourceQualifier).includes(qualifier)) {
            throw new Error(`Unknown Permission Resource Entity: ${qualifier}`);
        }
        resultResource = {
            qualifier,
            identifier: resourceParts[1],
        };
    }
    if (!resultResource) {
        throw new Error(`Permission resource: "${resource}" is currently unsupported`);
    }
    return resultResource;
}
exports.ParsePermissionResource = ParsePermissionResource;
function ParsePermission(permission) {
    return {
        action: permission.action,
        resourceType: permission.resourceType,
        resource: ParsePermissionResource(permission.resource),
        legacyId: permission.legacyId,
    };
}
exports.ParsePermission = ParsePermission;
function EncodePermissionResource(resource) {
    if (typeof resource === 'string') {
        return resource;
    }
    return `${resource.qualifier}:${resource.identifier}`;
}
exports.EncodePermissionResource = EncodePermissionResource;
function EncodePermission(permission) {
    return {
        ...permission,
        resource: EncodePermissionResource(permission.resource),
    };
}
exports.EncodePermission = EncodePermission;
function MatchesPermissionResource(permission, resource) {
    if (typeof resource !== 'string' && typeof permission.resource !== 'string') {
        const isMatchingQualifier = resource.qualifier === permission.resource.qualifier;
        if (isMatchingQualifier) {
            if (permission.resource.identifier === types_1.PermissionResourceAlias.All) {
                return true;
            }
            if (Array.isArray(resource.identifier)) {
                return resource.identifier.includes(resource.identifier);
            }
            return resource.identifier === permission.resource.identifier;
        }
    }
    return false;
}
exports.MatchesPermissionResource = MatchesPermissionResource;
function MatchesPermissionResourceRequest(permission, resource) {
    if (typeof resource !== 'string') {
        if (Array.isArray(resource.identifier)) {
            return resource.identifier.some((identifier) => MatchesPermissionResource(permission, { qualifier: resource.qualifier, identifier }));
        }
        return MatchesPermissionResource(permission, { qualifier: resource.qualifier, identifier: resource.identifier });
    }
    return MatchesPermissionResource(permission, resource);
}
exports.MatchesPermissionResourceRequest = MatchesPermissionResourceRequest;
//# sourceMappingURL=index.js.map